export function initializeCarousel(carousel) {
  const itemsContainer = carousel.querySelector('.cascade-list__items');
  const items = carousel.querySelectorAll('.upload');
  const prevBtn = carousel.querySelector('.cascade-list__controls__prev');
  const nextBtn = carousel.querySelector('.cascade-list__controls__next');

  let currentPosition = 0;

  prevBtn.addEventListener('click', function() {
    currentPosition--;
    updatePosition();
  });

  nextBtn.addEventListener('click', function() {
    currentPosition++;
    updatePosition();
  });

  function updatePosition() {
    items.forEach((item, index) => {
      const newPosition = index - currentPosition;

      if (newPosition === 0) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
      item.dataset.position = newPosition;
    });

    if (currentPosition === 0) {
      prevBtn.disabled = true;
    } else {
      prevBtn.disabled = false;
    }

    if (currentPosition === items.length - 1) {
      nextBtn.disabled = true;
    } else {
      nextBtn.disabled = false;
    }
  }

  updatePosition();
}